import { getContext } from 'svelte';
import { get } from 'svelte/store';
import { disconnect as wagmiDisconnect } from 'wagmi/actions';
import { ContextStateSymbol } from '../context';
export function useDisconnect() {
    const { config, wallet } = getContext(ContextStateSymbol);
    const disconnect = async () => {
        await wagmiDisconnect(get(config));
        wallet.set(null);
    };
    return disconnect;
}
